.dialogStyle :global(.cp-container [role='dialog']) {
	z-index: 350;
}

:global(#content-body) {
	background: var(--background);
	background-color: var(--background-color);
	background-image: var(--background-image);
	background-size: var(--background-size);
	background-position: var(--background-position);
	background-repeat: var(--background-repeat);
	background-attachment: var(--background-attachment);
	background-clip: var(--background-clip);
	background-origin: var(--background-origin);
	background-blend-mode: var(--background-blend-mode);
}
